import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import HotDramas from '@/pages/home/components/HotDramas';
import TvSeries from '@/pages/home/components/TvSeries';
import MoviePicks from '@/pages/home/components/MoviePicks';
import FullCollections from '@/pages/home/components/FullCollections';
import SourceGuide from '@/pages/home/components/SourceGuide';
import RankBoard from '@/pages/home/components/RankBoard';
import GenreExplore from '@/pages/home/components/GenreExplore';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <HotDramas />
        <TvSeries />
        <MoviePicks />
        <FullCollections />
        <SourceGuide />
        <RankBoard />
        <GenreExplore />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}